/**
 * A FINISHED game whose record never left the result card — the tab was closed or reloaded while «Что было самым
 * трудным?» was still open — is settled from its resume snapshot on the next start (./resume.ts
 * `settleResumableGame`: parked, then delivered). The shell listens here so such a game still brings what a finished
 * game brings besides the journal: the facts of «Путь пешки» 2.0 (a path game's step result and game fact, the played
 * game and its stickers — app/App.tsx). Tiny on purpose: the shell imports it statically, ./resume.ts stays a lazy chunk.
 */
import type { GameRecord } from '@gambit/shared';
import type { GameConfig } from './gameTypes.ts';

export type FinishedGameListener = (record: GameRecord, config: GameConfig) => void;

let listener: FinishedGameListener | null = null;

/** The shell's one listener (null removes it). */
export function onFinishedGameSettled(next: FinishedGameListener | null): void {
  listener = next;
}

/**
 * ./resume.ts: a finished game was settled from its snapshot. The listener runs a microtask later — a settle may happen
 * while a screen renders (GameScreen reads the snapshot in its first render), and the path's write makes other screens
 * update. A listener's problem never breaks the settling.
 */
export function notifyFinishedGameSettled(record: GameRecord, config: GameConfig): void {
  const run = listener;
  if (run === null) return;
  queueMicrotask(() => {
    try {
      run(record, config);
    } catch {
      // the journal still gets the game; the path's facts are a bonus here
    }
  });
}
